import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./i18n";
import vuetify from "./plugins/vuetify";
import admin from "./plugins/admin";
import "./plugins/i18n";
import "./plugins/base";
import "./plugins/chartist";
import "./sass/overrides.sass";
import Axios from "axios";
Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
  if (to.name !== 'Login' ){

        const tokenAccess = localStorage.getItem('tokenAccess');
        if( !tokenAccess ) return next({ name: 'Login' });
        let url = store.getters.['base_api'] + 'auth/get-user'
        Axios.create({
            baseURL: '/',
            headers: {'Authorization': `Bearer ${localStorage.getItem('tokenAccess')}`}
        })
        .get(url)
            .then(response => {
                let user = response['data'];
                i18n.locale = user.locale;
                if( Object.keys(user).length > 0){
                    store.commit('set_auth',user);
                    next();
                }else{
                  localStorage.clear();
                  return next({ name: 'Login' });
                }
            },
            error => {
                const {status} = error.response;
                if (status === 401) {
                    localStorage.clear();
                    next({ name: 'Login' });
                }
            })
            .catch( error => {
                console.log(error)
                localStorage.clear();
                next({ name: 'Login' });
            });

  }else{
    const tokenAccess = localStorage.getItem('tokenAccess');
        if( tokenAccess ){
            return next({ name: 'Landing' , params: {lagn: 'th'}});
        }
        next();
  }
});

new Vue({
  router,
  store,
  i18n,
  vuetify,
  admin,
  render: (h) => h(App),
}).$mount("#app");
